export const DaysComparator = (valueA, valueB) => {
  const extractDays = (val) => {
    if (!val) return null;

    // Strip HTML tags (like <p>, <span>, etc.)
    const plainText = val.replace(/<[^>]*>/g, '').trim().toLowerCase();

    // Handle edge cases
    if (["na", "-", "failed"].includes(plainText)) return null;

    // Extract number before "days"
    const match = plainText.match(/(\d+)\s*days?/i);
    return match ? parseInt(match[1], 10) : null;
  };

  const daysA = extractDays(valueA);
  const daysB = extractDays(valueB);

  if (daysA !== null && daysB !== null) return daysA - daysB;
  if (daysA !== null) return 1;
  if (daysB !== null) return -1;
  return 0;
};

// Comparator function
export const currencyComparator = (valueA, valueB) => {
  const extractNumber = (val) => {
    if (typeof val === 'number') return val;
    if (!val || typeof val !== 'string') return null;

    // Preserve minus sign and decimal
    const plainText = val.replace(/[^0-9.-]/g, '').trim();
    if (plainText === '' || plainText === '0') return 0;

    const num = parseFloat(plainText);
    return isNaN(num) ? null : num;
  };

  const numA = extractNumber(valueA);
  const numB = extractNumber(valueB);

  if (numA !== null && numB !== null) return numA - numB;
  if (numA !== null) return 1;
  if (numB !== null) return -1;
  return 0;
};


